import { Link } from "react-router-dom";
import { EmptyState } from "../components/EmptyState";
import { Seo } from "../components/Seo";

export function NotFoundPage() {
  return (
    <main id="main" className="page">
      <Seo title="Page not found" path="/404" />
      <EmptyState title="Page not found">That page is not here.</EmptyState>
      <p>
        <Link to="/">Return home</Link>
      </p>
    </main>
  );
}
